import { Injectable, inject, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { distinctUntilChanged, filter, switchMap, take } from 'rxjs/operators';
import { TenantService } from './tenantService';
import { AmplifyService } from 'src/app/amplify/amplify.service';

@Injectable({ providedIn: 'root' })
export class MaintenanceWatcherService implements OnDestroy {
  private readonly tenantService = inject(TenantService);
  private readonly amplifyService = inject(AmplifyService);
  private readonly router = inject(Router);
  private subscription?: Subscription;

  start(): void {
    if (this.subscription && !this.subscription.closed) {
      return;
    }

    this.subscription = this.router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd),
        take(1),
        switchMap(() =>
          this.tenantService.maintenanceMode$.pipe(
            distinctUntilChanged(),
            filter((isMaintenance) => isMaintenance),
            filter(() => !this.router.url.startsWith('/login')),
            take(1)
          )
        )
      )
      .subscribe(() => {
        void this.amplifyService
          .signOut()
          .catch(() => undefined)
          .finally(() => {
            globalThis.location.href = '/login?reason=maintenance';
          });
      });
  }

  stop(): void {
    this.subscription?.unsubscribe();
    this.subscription = undefined;
  }

  ngOnDestroy(): void {
    this.stop();
  }
}
